import { Button, DesignV2Scope, MobilePage } from "../design-v2";
import "../features/onboarding/onboarding.css";
import "./auth.css";

function BackIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M14.5 5 7.5 12l7 7" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function AuthHeader({ onBack, backLabel = "Go back" }) {
  return (
    <div className="lz-auth-header">
      {onBack ? (
        <Button
          variant="ghost"
          size="icon"
          className="lz-auth-header__back"
          aria-label={backLabel}
          onClick={onBack}
        >
          <BackIcon />
        </Button>
      ) : null}
      <div className="lz-onboarding-brand-header">
        <p className="font-lz-v2-display text-lg font-bold uppercase text-lz-v2-text-strong">
          Lyft <span className="text-lz-v2-action">Zone</span>
        </p>
      </div>
    </div>
  );
}

export default function AuthLayout({
  children,
  onBack,
  backLabel,
  hasStickyActions = false,
}) {
  return (
    <DesignV2Scope>
      <MobilePage
        className="lz-auth-page"
        contentClassName="lz-auth-page__content"
        hasStickyActions={hasStickyActions}
        header={<AuthHeader onBack={onBack} backLabel={backLabel} />}
      >
        {children}
      </MobilePage>
    </DesignV2Scope>
  );
}

export { AuthHeader };
